import { Link } from "wouter";

interface AccessBudgetsCardProps {
  description?: string;
  buttonText?: string;
  buttonLink?: string;
}

export function AccessBudgetsCard({
  description = "Lorem ipsum dolor sit amet consectetur. Sed eget cursus eget rhoncus aenean malesuada nunc. Aliquet condimentum id volutpat turpis pretium nec posuere elit nulla.",
  buttonText = "Ir para orçamentos",
  buttonLink = "/financeiro/orcamentos",
}: AccessBudgetsCardProps) {
  return (
    <div className="border border-[#7846FF] h-[252px] rounded-[10px] w-full">
      <div className="box-border flex flex-col gap-[20px] h-[252px] items-start overflow-clip p-[30px] rounded-[inherit] w-full">
        {/* Title */}
        <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-white text-[16px] whitespace-pre">
          Acessar Orçamentos
        </p>

        {/* Description */}
        <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#f6f6f6] text-[14px] w-full">
          {description}
        </p>

        {/* CTA Button */}
        <Link href={buttonLink}>
          <button className="bg-[#7846FF] box-border flex gap-[3px] h-[50px] items-center justify-center p-[10px] rounded-[10px] w-[220px] hover:bg-[#6835E6] transition-colors">
            <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-[#f5f2ff] text-[18px] whitespace-pre">
              {buttonText}
            </p>
          </button>
        </Link>
      </div>
    </div>
  );
}
